import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'dewatering';
// Fixed slots: img[0-3] paired with process steps in alternating rows | Additional: img[4+]

const Dewatering = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const steps = data.processSteps || [];
  const FIXED_SLOTS = 4;
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="dw-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        <div className="dw-intro">
          <p>{data.intro}</p>
          <p>{data.intro2}</p>
        </div>

        {/* Alternating rows: each step paired with its image only if image exists */}
        {steps.length > 0 && (
          <>
            <h2 style={{ color: '#1a3a5c', fontSize: '1.4rem', marginBottom: 20 }}>{data.processTitle}</h2>
            <div className="dw-alternating">
              {steps.map((s, i) => (
                imgs[i] ? (
                  /* Full alternating row with image */
                  <div className={`dw-alt-row${i % 2 === 1 ? ' reverse' : ''}`} key={s.step}>
                    <div className="dw-alt-img">
                      <img src={imgs[i].url} alt={imgs[i].caption || s.title} />
                    </div>
                    <div className="dw-alt-text">
                      <h3>Step {s.step}: {s.title}</h3>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ) : (
                  /* Text-only step card when no image */
                  <div className="dw-step-text-only" key={s.step}>
                    <div className="dw-step-num">{s.step}</div>
                    <div>
                      <h3>{s.title}</h3>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                )
              ))}
            </div>
          </>
        )}

        {data.features && data.features.length > 0 && (
          <div className="dw-feat-grid">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="dw-feat" key={f.title}>
                <span>{f.icon}</span>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="dw-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > FIXED_SLOTS && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(FIXED_SLOTS).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default Dewatering;
